import { FC, memo } from 'react';

import UploadedImageRow from '../shared/UploadedImageRow';
import SettingsModal, { getWatermarkTag } from './SettingsModal';
import { ImageData } from './index';

interface Props {
  image: ImageData;
  imageIndex: number;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
  type: 'left' | 'right';
  preview?: boolean;
  settings?: boolean;
}

const NewUploadedImageRow: FC<Props> = ({
  image,
  imageIndex,
  setImages,
  type,
  preview,
  settings,
}) => {
  const settingsApplied =
    image.divider !== 'white' ||
    image.brakes ||
    !image.quotes ||
    getWatermarkTag(image) !== 'none' ||
    image.textPosition !== 'bottom';

  return (
    <UploadedImageRow
      image={image}
      imageIndex={imageIndex}
      setImages={setImages as any}
      showPreview={preview}
      showSettings={settings}
      settingsApplied={settingsApplied}
      settingsModal={
        <SettingsModal
          image={image}
          imageIndex={imageIndex}
          setImages={setImages}
          type={type}
          onClose={() => {}}
        />
      }
    />
  );
};

export default memo(NewUploadedImageRow);
